import React from 'react'
import NormalNotice from './NormalNotice'
import "../../stylings/notice.css"

const Notices = ({loadNotice}) => {
    return (
        <div className='container notice-container'>
            <div className="row notices-row">
                <div className="col-12">
                    <NormalNotice loadNotice={loadNotice}/>
                </div>
            </div>
        </div>
    )
}

export default Notices
